import { component } from "picoapp";
import {
  CAROUSEL_INTERSECTION_SETTINGS,
  PAGE_CAROUSEL_OPTIONS,
  PAGINATION_ACTIVE_CLASS,
  PAGINATION_INACTIVE_CLASS,
  SLIDE_FADE_CLASS,
} from "../tbsp-carousel--constants";

export const paginatedCarousel = component(async (node: HTMLElement) => {
  const isVideoEnabled = node.dataset.videoEnabled === "true";
  const isPausingEnabled = node.dataset.pausingEnabled === "true";
  const isFadeEnabled = node.dataset.fadeInactive === "true";
  const isLoopingEnabled = node.dataset.loopingEnabled === "true";
  const isPaginationEnabled = node.dataset.paginationEnabled === "true";
  const slideGap = node.dataset.slideGap;
  const mdSlideGap = node.dataset.mdSlideGap;

  const [{ default: Splide }, { Intersection }] = await Promise.all([
    import("@splidejs/splide"),
    import("@splidejs/splide-extension-intersection"),
    // @ts-ignore
    import("@splidejs/splide/css/core"),
  ]);

  const derivedGap = slideGap ? parseInt(slideGap) : PAGE_CAROUSEL_OPTIONS.gap;

  const splide = new Splide(node, {
    ...PAGE_CAROUSEL_OPTIONS,
    type: isLoopingEnabled ? "loop" : PAGE_CAROUSEL_OPTIONS.type,
    pagination: isPaginationEnabled,
    gap: derivedGap,

    breakpoints: {
      ...PAGE_CAROUSEL_OPTIONS.breakpoints,
      768: {
        ...PAGE_CAROUSEL_OPTIONS.breakpoints[768],
        gap: mdSlideGap ? parseInt(mdSlideGap) : derivedGap,
      },
    },

    ...CAROUSEL_INTERSECTION_SETTINGS,
  });

  if (isVideoEnabled) {
    splide.on("intersection:in", function (entry) {
      splide.on("active", ({ slide }) => {
        const video = slide.querySelector("video");

        if (video && isPausingEnabled) {
          video.play().catch();
        }
      });

      splide.on("inactive", ({ slide }) => {
        const video = slide.querySelector("video");

        if (video && isPausingEnabled) {
          video.muted = true;
          video.pause();
        }
      });

      node.querySelectorAll("video").forEach((video) => {
        video.preload = "auto";
      });
    });
  }

  if (isFadeEnabled) {
    node
      .querySelectorAll(".splide__slide")
      .forEach((slide) => slide.classList.add(SLIDE_FADE_CLASS));

    splide.on("active", ({ slide }) => {
      slide.classList.remove(SLIDE_FADE_CLASS);
    });

    splide.on("inactive", ({ slide }) => {
      slide.classList.add(SLIDE_FADE_CLASS);
    });

    splide.on("click", ({ index }) => {
      splide.go(index);
    });
  }

  if (isPaginationEnabled) {
    splide.on("pagination:updated", (_, prev, curr) => {
      prev.button.classList.add(PAGINATION_INACTIVE_CLASS);
      prev.button.classList.remove(PAGINATION_ACTIVE_CLASS);

      curr.button.classList.add(PAGINATION_ACTIVE_CLASS);
      curr.button.classList.remove(PAGINATION_INACTIVE_CLASS);
    });
  }

  splide.mount({ Intersection });
});
